import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    resoruces: {}
  },
  mutations: {
    SET_RESOURCES (store, val) {
      store.resoruces = val
    }
  },
  getters: {
    getResources: (store) => {
      return store.resoruces
    }
  },
  actions: {
    /*
    setResources
    */
    setResources ({commit, dispatch, getters}) {
      return new Promise((resolve, reject) => {
        axios
        .get('/resources')
        .then((response) => {
          commit('SET_RESOURCES', response.data)
          resolve(getters.getResources)
        })
        .catch((err) => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Resource.js